import { render, staticRenderFns } from "./PaperStore.vue?vue&type=template&id=9e0d882e&scoped=true&"
import script from "./PaperStore.vue?vue&type=script&lang=js&"
export * from "./PaperStore.vue?vue&type=script&lang=js&"
import style0 from "./PaperStore.vue?vue&type=style&index=0&id=9e0d882e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e0d882e",
  null
  
)

export default component.exports